import { InfoCircleOutlined } from '@ant-design/icons';
import { ReactNode } from 'react';
import './PageInfoCard.css';

type PageInfoCardProps = {
	title?: string;
	description: string;
	className?: string;
};

const renderInlineMarkdown = (text: string): ReactNode[] => {
	const parts = text.split(/(\*\*[^*]+\*\*)/g);
	return parts.map((part, index) => {
		if (part.startsWith('**') && part.endsWith('**')) {
			return <b key={index}>{part.slice(2, -2)}</b>;
		}
		return <span key={index}>{part}</span>;
	});
};

const renderBlock = (block: string, index: number) => {
	const lines = block.split('\n').map((line) => line.trim()).filter(Boolean);
	const isList = lines.length > 0 && lines.every((line) => line.startsWith('- '));

	if (isList) {
		return (
			<ul key={index} className='page-info-card-list'>
				{lines.map((line, lineIndex) => (
					<li key={lineIndex}>{renderInlineMarkdown(line.slice(2))}</li>
				))}
			</ul>
		);
	}

	return <p key={index}>{renderInlineMarkdown(block)}</p>;
};

export const PageInfoCard = ({
	title = 'Sobre esta pantalla',
	description,
	className = '',
}: PageInfoCardProps) => (
	<div className={`page-info-card ${className}`.trim()}>
		<div className='page-info-card-title'>
			<InfoCircleOutlined />
			{title}
		</div>
		<div className='page-info-card-body'>
			{description.split(/\n\n+/).map(renderBlock)}
		</div>
	</div>
);
